import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { api, logout as clearTokens } from "../http";

export const userInfoQueryOptions = queryOptions({
  queryKey: ["auth", "me"],
  queryFn: () => api.auth.me().then((r) => r.json()),
  retry(failureCount, error) {
    if (error instanceof Error && "response" in error) {
      const status = (error as { response: { status: number } }).response
        .status;
      if (status === 401 || status === 403 || status === 429) return false;
    }
    return failureCount < 3;
  },
});

export function useLogoutMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      // Call the logout endpoint on the server
      await api.raw.post("api/v1/auth/logout");
      // Clear local tokens
      clearTokens();
    },
    onSuccess: () => {
      // Clear all cached queries
      queryClient.clear();
    },
  });
}
